import * as yup from 'yup';
import { phoneRegex } from '../../constants';

export const schema = yup
  .object()
  .shape({
    ownerName: yup.string().required('Name is required.'),
    city: yup.string().required('City is required.'),
    mobileNumber: yup
      .string()
      .required('Mobile number is required')
      .matches(phoneRegex, 'Invalid mobile number'),
  })
  .required();
